<div class="submission-allocation-changes-card">
  <div class="d-flex flex-column gap-2">
    <div class="submission-allocation-changes-title" i18n>Fund Allocation</div>
    <div *ngIf="allocationsHaveChanged$ | async" class="submission-allocation-changes-description" i18n>
      {{ descriptionText }}
    </div>
    <div *ngIf="!(allocationsHaveChanged$ | async)" class="submission-allocation-changes-description" i18n>
      No Changes
    </div>
  </div>
  <ng-container *ngIf="allocationsHaveChanged$ | async">
    <div class="d-flex gap-4 flex-wrap">
      <div class="flex-grow-1">
        <app-fund-allocation-visualization
          label="Previous"
          i18n-label
          [donutChartData]="previousAllocationDonutChartData$ | async"
          [borderColor]="'transparent'"
          [backgroundColor]="'#FFEAEB'" />
      </div>
      <div class="flex-grow-1">
        <app-fund-allocation-visualization
          label="New"
          i18n-label
          [donutChartData]="newAllocationDonutChartData$ | async"
          [borderColor]="'transparent'"
          [backgroundColor]="'#E8F7D9'" />
      </div>
    </div>
  </ng-container>
</div>
